import BigNumber from 'bignumber.js';

export type EditTpSlBaseline = {
  tp: string;
  sl: string;
};

export const getEditTpSlBaseline = ({
  takeProfit,
  stopLoss,
  priceDisplayDecimals,
}: {
  takeProfit: BigNumber;
  stopLoss: BigNumber;
  priceDisplayDecimals: number;
}): EditTpSlBaseline => ({
  tp: takeProfit.toFixed(priceDisplayDecimals),
  sl: stopLoss.isZero() ? '' : stopLoss.toFixed(priceDisplayDecimals),
});
